import { Uso_publico } from './../../../models/uso_publico.model';
import { Component } from "@angular/core";
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { FormService } from 'src/app/services/form.service';

@Component({
    selector: "page-uso_publico",
    templateUrl: "./uso_publico.component.html",
    styleUrls: ["./uso_publico.component.css"],
    providers: [FormService]
})

export class Uso_publicoComponent {
      public rows = [];
      public actualRow;
      public uso_publico: Uso_publico;
      public form;
      public matcher = new FormService();

      constructor(){
        this.form = new FormGroup({
            uso_publico: new FormControl('', Validators.required),
        })
        if(!JSON.parse(localStorage.getItem("uso_publico"))){
            localStorage.setItem("uso_publico", JSON.stringify(this.rows));
        }else{
            this.rows = JSON.parse(localStorage.getItem("uso_publico"));
            this.form.controls['uso_publico'].setValue(this.rows[0]?this.rows[0].uso_publico:'');
        }
         this.uso_publico = {uso_publico:''};
    }

    add_uso_publico(){
        localStorage.setItem("uso_publico",JSON.stringify([]));
        this.actualRow = localStorage.getItem("uso_publico");
        this.rows = JSON.parse(this.actualRow);
        this.rows = this.rows.concat({
            uso_publico: this.form.value.uso_publico,
       })
        localStorage.setItem("uso_publico", JSON.stringify(this.rows));
    
    }

    delete_uso_publico(id){
        for(let x = 0; x < this.rows.length; x++){
            if(id == x){
                this.rows.splice(x, 1);
                localStorage.setItem("autorizaciones", JSON.stringify(this.rows));
            }
        }
    }

}